import Headhesive from 'headhesive';
import MainNav from './main-nav';


initSearchToggle();
initNavToggle('.page-header');
new MainNav('.main-nav');
new Headhesive('.page-header', {
  offset: 100,
  classes: {
    clone: 'page-header--clone',
    stick: 'page-header--stick',
    unstick: 'page-header--unstick',
  },
  onInit: () => {
    new MainNav('.page-header--clone .main-nav');
    initNavToggle('.page-header--clone');
  }
});

function initNavToggle(el) {
  const pageHeader = typeof el == 'string' ? document.querySelector(el) : el;
  pageHeader.querySelector('.main-nav__trigger').onclick = e => {
    document.documentElement.classList.toggle('show-main-nav');
    pageHeader.classList.toggle('page-header--nav-active');
  }
}

function initSearchToggle() {
  const search = document.querySelector('.js-search')
  const searchToggle = document.querySelector('.js-search-toggle')
  const searchClose = document.querySelector('.js-search-close')

  searchToggle.onclick = e => {
    searchToggle.classList.toggle('active')
    search.classList.toggle('visible')
  }

  searchClose.onclick = e => {
    searchToggle.classList.remove('active')
    search.classList.remove('visible')
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/js/header/index.js
// module id = 1
// module chunks = 0